import { __awaiter, __generator } from "tslib";
import { fetchIdentity, getOfficeIdentity, } from '@office-start/identity-service';
export function isConsumerUser() {
    return __awaiter(this, void 0, void 0, function () {
        var identityResult, identity, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    identityResult = getOfficeIdentity();
                    if (!identityResult) return [3 /*break*/, 1];
                    _a = identityResult;
                    return [3 /*break*/, 3];
                case 1: return [4 /*yield*/, fetchIdentity()];
                case 2:
                    _a = _b.sent();
                    _b.label = 3;
                case 3:
                    identity = _a;
                    return [2 /*return*/, identity.isMsa];
            }
        });
    });
}
//# sourceMappingURL=isConsumerUser.js.map